export const useProductUrls = () => {
  const getAlgoliaProductIdFromSlug = (url: string) =>
    url.split('-cod-')[1].replaceAll('-', '_')

  return {
    getAlgoliaProductIdFromSlug,
  }
}
